// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"52":"cfcc1123","228":"9886d57e"}[chunkId] + ".chunk.js");